<template>
  <div>
    <strong v-if="!node.title">{{ node.name }}</strong>
    <p v-if="node.url">
      <a :href="node.text" target="_blank">{{ node.text }}</a>
    </p>
    <p
      v-else
      :class="{
        collapsible: node.collapsible,
        'collapsible-collapsed': node.collapsible && node.collapsed
      }"
      @click="node.collapsed = !node.collapsed"
      v-html="docText"
    ></p>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    node: {
      type: Object,
      required: true
    },
    words: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      docText: ""
    }
  },
  mounted() {
    this.hiLite();
  },
  methods: {
    hiLite(){
      this.docText = _.toLower(this.node.text);
      let words = _.join(this.words, ",").split(',');
      if(this.words && this.words.length>0){
        words.forEach(word => {
          this.docText = _.replace(this.docText, _.toLower(_.trim(word)), "<span style='background:#F07E2A; color:#ffffff'>"+_.trim(word)+"</span>");
        });
      }
    }
  }
};
</script>
